import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PATHS } from '@/sites/op7/routes/paths';
import { EPopupWindowKey, windowManager } from '@/common/hooks/popupWindows/windowManager';
import { EBetHistoryQueryType } from '@/apis/commonSports/constants';

export function usePopupWindowConnect() {
  useEffect(() => {
    windowManager.reconnectAll();
  }, []);
}

/**
 * 封装所有需要以弹出窗口打开的页面入口。
 * 新增窗口类型时，在这里补一个 open 方法即可。
 */
export function usePopupWindows() {
  const { i18n } = useTranslation();
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const lang = i18n.language;

  const openBetHistoryWindow = useCallback(
    (queryType?: EBetHistoryQueryType) => {
      let url = `${origin}/${lang}${PATHS.betHistoryPc}`;
      if (queryType) {
        url += `?queryType=${queryType}`;
      }
      windowManager.open(EPopupWindowKey.BetHistory, url);
    },
    [origin, lang],
  );

  const openSportsPageWindow = useCallback(
    (path: string, extraSearchParams?: URLSearchParams) => {
      const queryString = extraSearchParams?.toString();
      const url = `${origin}/${lang}${path}${queryString ? `?${queryString}` : ''}`;
      windowManager.open(EPopupWindowKey.SportsPopup, url);
    },
    [origin, lang],
  );

  const openResultWindow = useCallback(() => {
    openSportsPageWindow(PATHS.result);
  }, [openSportsPageWindow]);

  const openSportsRulesWindow = useCallback(
    (questionId: number) => {
      openSportsPageWindow(
        PATHS.sportsRulesPc,
        new URLSearchParams({ questionId: String(questionId) }),
      );
    },
    [openSportsPageWindow],
  );

  const openBettingTutorialWindow = useCallback(
    (questionId: number) => {
      openSportsPageWindow(
        PATHS.bettingTutorialPc,
        new URLSearchParams({ questionId: String(questionId) }),
      );
    },
    [openSportsPageWindow],
  );

  return {
    openBetHistoryWindow,
    openResultWindow,
    openSportsRulesWindow,
    openBettingTutorialWindow,
  };
}
